import React from 'react';
import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-icon">
          <svg viewBox="0 0 24 24" fill="currentColor" width="120" height="120">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Siden blev ikke fundet</h2>
        
        <p className="not-found-description">
          Den side du leder efter eksisterer ikke eller er blevet flyttet.
        </p>
        
        <div className="not-found-actions">
          <button 
            onClick={handleGoHome}
            className="not-found-button primary"
          >
            Gå til forsiden
          </button>
          
          <button 
            onClick={handleGoBack}
            className="not-found-button secondary"
          >
            Gå tilbage
          </button>
        </div>
        
        <div className="not-found-help">
          <p>Du kan også prøve at:</p>
          <ul>
            <li>Tjekke URL'en for stavefejl</li>
            <li>Gå til forsiden og navigere derfra</li>
            <li>Kontakte os hvis du mener dette er en fejl</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
